<template>
  <div v-if="isVisible" class="language-selector">
    <div class="_flex:align(center)">
      <ds ds="icon" name="language" class="_m:right(1)" color="var(--grey-800)" size="16px" />
      <ds
        ds="select-simple"
        v-if="languageOptions"
        name="language"
        label=" "
        :isFloatLabel="true"
        :isMini="true"
        :value.sync="selectedLanguage"
        :options="languageOptions"
        :isSearchable="false"
      />
    </div>
  </div>
</template>

<script>

import { mapActions, mapGetters } from 'vuex';

export default {
  name: 'LanguageSelector',
  computed: {
    ...mapGetters(
      {
        isLoggedIn: 'tokeny/isLoggedIn',
        languages: 'qualification/languages',
        locale: 'locale/locale',
        locales: 'locale/locales',
        qualification: 'qualification/qualification'
      }
    ),
    languageOptions () {
      return this.languages.flatMap(
        lang => this.locales.filter(loc => loc === lang)
      ).map(
        lang => ({ label: this.$t('locale', lang), value: lang })
      );
    },
    isVisible () {
      return this.languageOptions.length > 1;
    }
  },
  watch: {
    async selectedLanguage () {
      if (this.selectedLanguage && this.selectedLanguage !== this.locale) {
        this.setLocale(this.selectedLanguage);

        if (this.isLoggedIn) {
          await this.investorLanguage(this.selectedLanguage);
          await this.fetchMissingDisclaimers();
        }
        // do not fetch qualification before signIn
        if (this.qualification) {
          await this.fetchQualification();
        }
      }
    },
    languages: {
      immediate: true, // run on mount
      async handler () {
        if (!this.languageOptions.length) return;

        const loValues = this.languageOptions.map(lo => lo.value);
        if (!loValues.includes(this.locale)) {
          // locale from webpack locale list or previous state was not found
          const navLang = window.navigator.language ? window.navigator.language.substring(0, 2).toLowerCase() : '';

          // first try to match nav.lang
          let matchedLocale = loValues.find(lo => lo === navLang);
          if (!matchedLocale && Array.isArray(window.navigator.languages)) {
            // no match, try any nav.langs
            for (const lang of window.navigator.languages) {
              matchedLocale = loValues.find(lo => lo === lang.substring(0, 2).toLowerCase());
              if (matchedLocale) break; // found one
            }
          }
          if (!matchedLocale) {
            // no match, default to first
            matchedLocale = loValues[0];
          }
          this.setLocale(matchedLocale);
        }

        this.selectedLanguage = this.locale;
      }
    }
  },
  data: () => ({
    selectedLanguage: null
  }),
  methods: {
    ...mapActions(
      {
        fetchLanguages: 'qualification/fetchLanguages',
        fetchQualification: 'qualification/fetchQualification',
        setLocale: 'locale/setLocale',
        investorLanguage: 'qualification/investorLanguage',
        fetchMissingDisclaimers: 'qualification/fetchMissingDisclaimers'
      }
    )
  },
  async mounted () {
    await this.fetchLanguages();
  }
};
</script>

<style lang="less">
@import "~@/utils.less";

.language-selector {
  ._text\:sm;

  ds-select-simple, ds-select, ds-select-multiple {
    min-width: 7rem;
  }

  // @todo remove this workaround pending https://tokeny.atlassian.net/browse/DS-137
  input {
    max-height: 1rem;
  }
}
</style>
